module.exports = __webpack_public_path__ + "img/banner.93272b3f.jpg";